import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';

export function TrialPlan({ title, trialPlanPrice, discount }) {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				py: '20px',
				borderTop: '1px solid #E8E8E8',
				borderBottom: '1px solid #E8E8E8'
			}}
		>
			<Stack flexDirection="row" justifyContent="space-between">
				<Typography variant="body3" fontWeight={400}>
					{title}
				</Typography>

				<Stack direction="row" alignItems="center" spacing={1} useFlexGap>
					{!!discount && (
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							sx={theme => ({
								background: theme.palette.text.primary,
								px: 0.5,
								height: 20,
								borderRadius: 1
							})}
						>
							<Typography
								variant="body0"
								fontWeight={700}
								color="background.default"
							>
								{t('common.discount', {
									discount
								})}
							</Typography>
						</Box>
					)}
					<Typography
						variant="body3"
						fontWeight={700}
						sx={{
							lineHeight: '28px',
							fontSize: '24px'
						}}
					>
						{trialPlanPrice}
					</Typography>
				</Stack>
			</Stack>
		</Box>
	);
}
